import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="New NSW Syllabus"
      description="2026 teacher planning resource"
      slug={props.location.pathname}
    />
  );
}

function NSWSyllabusPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="New NSW Syllabus"
        subtitle="2026 teacher planning resource"
        id="NSW_SYLLABUS_2026"
        redirectUrl="https://stileapp.com/go/nswsyllabus"
        image={
          <StaticImage
            src="../../../../stile-shared/assets/images/nsw/nsw_syllabus_imp_guide_cropped.jpg"
            alt="Cover page of a document titled 'The New South Wales Science 7–10 Syllabus: Our guide to preparing for implementation.' Stile logo in green on a light background."
          />
        }
      >
        <p>
          Stile is a complete, coherent curriculum for science classrooms in New South Wales. This
          document outlines the changes to the NSW Syllabus and Stile’s alignment to the changes
          over the next two years.
        </p>
        <p>
          Use our Scope and Sequence as a world-class starting point for designing your school’s
          science curriculum. Alongside our helpful teaching plans and lab guides, it offers all the
          support that graduate teachers need, while the ability to customise gives experienced
          teachers flexibility and freedom.
        </p>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default NSWSyllabusPage;
